import { render, staticRenderFns } from "./upd-psw-modal.vue?vue&type=template&id=0dbd4de0&"
import script from "./upd-psw-modal.vue?vue&type=script&lang=js&"
export * from "./upd-psw-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports